import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Header,
  Icon,
  Loader,
  Card,
  Message,
} from "semantic-ui-react";
import StudentCard from "../components/StudentCard";
import { GET_ASSISTANT_PROFILE } from "../GraphQL";
import UserContext from "contexts/UserContext";

const AssistantPage = () => {
  const user = useContext(UserContext);
  const { loading, error, data } = useQuery(GET_ASSISTANT_PROFILE);

  let pageContent = null;

  if (loading) {
    pageContent = <Loader active />;
  } else if (error) {
    throw error;
  } else {
    const myTeachers = data.myProfile.teachers;

    pageContent =
      myTeachers.length > 0 ? (
        <div style={{ marginTop: "1em", clear: "both" }}>
          {myTeachers.map((t, i) => (
            <div key={i}>
              <Header dividing>{t.name}</Header>
              <Card.Group stackable>
                {t.students
                  .filter((s) => s.archived !== true)
                  .map((student, j) => (
                    <StudentCard key={`${i}-${j}`} student={student} />
                  ))}
              </Card.Group>
            </div>
          ))}
        </div>
      ) : (
        <Header>You are not assisting any teachers at this time.</Header>
      );
  }

  const showProfileMessage = user.getAttributes().name === undefined;
  const profileMessage = (
    <Message info icon>
      <Icon name="user circle" />
      <Message.Content>
        <Message.Header>Update your profile</Message.Header>
        Howdy, stranger! Why don't you tell us your <a href="/settings">name</a>
        , and maybe your <Link to="/settings">phone number</Link> to receive
        text alerts.
      </Message.Content>
    </Message>
  );

  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/">Home</Link>
        </Breadcrumb.Section>
      </Breadcrumb>
      {showProfileMessage ? profileMessage : null}
      {pageContent}
    </div>
  );
};

export default AssistantPage;
